import { BaseCategory, BaseCategoryEdit } from './base-category.model';

export class ServiceCategory extends BaseCategory {}

export class ServiceCategoryEdit extends BaseCategoryEdit {}
